import { Component, Inject, OnInit, signal } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { IconImageService } from "@shared/services/icon-image.service"

export type FlowConfirmDialogResult = "confirm" | "cancel" | "discard"

export interface FlowConfirmDialogQuantity {
  label: string
  max: number
  min?: number
  initial?: number
}

export interface FlowConfirmDialogData {
  title: string
  description?: string
  confirmButtonText?: string
  confirmButtonType?: "primary" | "destructive"
  cancelButtonText?: string
  discardButtonText?: string
  alertboxTitle?: string
  alertboxDescription?: string
  width?: string
  quantity?: FlowConfirmDialogQuantity
}

@Component({
  selector: "flow-confirm-dialog",
  templateUrl: "./flow-confirm-dialog.component.html",
  styleUrls: ["./flow-confirm-dialog.component.scss"],
  standalone: false,
})
export class FlowConfirmDialogComponent implements OnInit {
  public confirmText = "Confirm"
  public cancelText = "Cancel"
  public confirmType: "primary" | "destructive" = "primary"

  public quantity = signal(1)
  // read by the caller from the dialog instance; the result union stays "confirm" | "cancel" for existing call sites
  public confirmedQuantity: number | null = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FlowConfirmDialogData,
    public dialogRef: MatDialogRef<FlowConfirmDialogComponent, FlowConfirmDialogResult>,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.confirmText = this.data.confirmButtonText ?? "Confirm"
    this.cancelText = this.data.cancelButtonText ?? "Cancel"
    this.confirmType = this.data.confirmButtonType ?? "primary"
    this.quantity.set(this.data.quantity?.initial ?? this.data.quantity?.max ?? 1)
    this.dialogRef.updateSize(this.data.width ?? "580px")
    this.dialogRef.addPanelClass("flow-confirm-dialog-panel")
  }

  public get minimumQuantity(): number {
    return this.data.quantity?.min ?? 1
  }

  onQuantityChanged(value: number): void {
    this.quantity.set(value)
  }

  onConfirm(): void {
    this.confirmedQuantity = this.data.quantity ? this.quantity() : null
    this.dialogRef.close("confirm")
  }

  onCancel(): void {
    this.dialogRef.close("cancel")
  }

  onDiscard(): void {
    this.dialogRef.close("discard")
  }
}
